import React from "react";

const WhyWorkWithUs = () => {

    const benefits = [
        {
            number: "01",
            title: "Career Growth",
            desc: "Work on challenging projects, gain real-world experience and accelerate your career with expert mentorship.",
            className: "small"
        },
        {
            number: "02",
            title: "Learning Culture",
            desc: "Continuous learning through workshops, collaboration and exposure to new technologies.",
            className: "small"
        },
        {
            number: "03",
            title: "Innovation",
            desc: "Build modern digital products using React, Flutter, AI and next-generation technologies.",
            className: "small"
        },
        {
            number: "04",
            title: "Remote Flexibility",
            desc: "Flexible work environment that helps you stay productive while maintaining work-life balance.",
            className: "small"
        }
    ];

    return (
        <>
            <section className="wwu-section">

                <div className="wwu-glow glow-1"></div>
                <div className="wwu-glow glow-2"></div>

                <div className="wwu-container">

                    <div className="wwu-header">

                        <span>
                            WHY WORK WITH US
                        </span>

                        <h2>
                            We Build
                            <br />
                            Great Careers.
                        </h2>

                        <p>
                            Join a team where innovation, ownership,
                            growth and creativity come together to
                            build world-class digital experiences.
                        </p>

                    </div>

                    <div className="wwu-grid">

                        {benefits.map((item, index) => (

                            <div
                                key={index}
                                className={`wwu-card ${item.className}`}
                            >

                                <div className="wwu-number">
                                    {item.number}
                                </div>

                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.desc}
                                </p>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .wwu-section{
                    position:relative;
                    overflow:hidden;
                    padding:150px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #fff,
                        #fff8f8,
                        #fff
                    );
                }

                .wwu-container{
                    max-width:1400px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .wwu-header{
                    text-align:center;
                    margin-bottom:80px;
                }

                .wwu-header span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:24px;
                }

                .wwu-header h2{
                    font-size:clamp(35px,8vw,58px);
                    line-height:.95;
                    color:#111;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                    text-align: center;
                }

                .wwu-header p{
                    max-width:760px;
                    text-align: center;
                    margin:auto;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                }

                .wwu-grid{
                    display:grid;
                    grid-template-columns:Auto Auto;
                    gap:25px;
                }

                .wwu-card{
                    background:#fff;
                    border-radius:36px;
                    padding:45px;
                    border:1px solid #eee;
                    transition:.45s ease;
                    position:relative;
                    overflow:hidden;
                    box-shadow:
                    0 15px 40px rgba(0,0,0,.04);
                }

                .wwu-card:hover{
                    transform:translateY(-12px);
                    border-color:#E8212A;
                    box-shadow:
                    0 25px 80px rgba(232,33,42,.12);
                }

                .wwu-card::before{
                    content:"";
                    position:absolute;
                    width:280px;
                    height:280px;
                    border-radius:50%;
                    background:
                    radial-gradient(
                        rgba(232,33,42,.12),
                        transparent
                    );
                    top:-120px;
                    right:-120px;
                    transition:.5s;
                }

                .wwu-card:hover::before{
                    transform:scale(1.3);
                }

                .wwu-number{
                    font-size:70px;
                    font-weight:800;
                    line-height:1;
                    margin-bottom:25px;
                    color:#E8212A;
                    font-family:'Syne',sans-serif;
                }

                .wwu-card h3{
                    font-size:38px;
                    margin-bottom:18px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .wwu-card p{
                    color:#666;
                    line-height:1.9;
                    font-size:16px;
                }

                .large{
                    min-height:420px;
                }

                .small{
                    min-height:200px;
                }

                .wide{
                    grid-column:span 2;
                    min-height:240px;
                }

                .wwu-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .glow-1{
                    width:400px;
                    height:400px;
                    background:#E8212A;
                    left:-120px;
                    top:-120px;
                }

                .glow-2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-120px;
                    bottom:-120px;
                }

                @media(max-width:991px){

                    .wwu-grid{
                        grid-template-columns:1fr;
                    }

                    .wide{
                        grid-column:span 1;
                    }

                }

                @media(max-width:768px){

                    .wwu-section{
                        padding:100px 18px;
                    }

                    .wwu-header h2{
                        letter-spacing:-2px;
                    }

                    .wwu-card{
                        padding:30px;
                    }

                    .wwu-number{
                        font-size:52px;
                    }

                    .wwu-card h3{
                        font-size:28px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default WhyWorkWithUs;